import React from 'react';

import { IconButton, Image } from 'components';
import { Modal } from 'components/Modal/Modal.component';
import { ButtonV3 } from 'components/ComponentV2';
import { PAGE_ROUTES } from 'lib/page-routes';

import styles from './QRCodeModal.module.scss';

interface QRCodeModalProps {
  open: boolean;
  societyName: string;
  qrCodeUrl: string;
  slug: string;
  onClose: () => void;
}

export const QRCodeModal: React.FC<QRCodeModalProps> = (
  props: QRCodeModalProps
) => {
  const { open, societyName, qrCodeUrl, slug, onClose } = props;

  const downloadQR = () => {
    window.open(qrCodeUrl, '_blank');
  };

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      contentClassName={styles.qrCodeModal}
    >
      <div className={styles.qrCodeModalHeader}>
        <p className={styles.title}>{societyName}</p>
        <IconButton
          iconName="close"
          size="small"
          className={styles.closeIcon}
          onClick={onClose}
        />
      </div>
      <div className={styles.qrCodeModalContent}>
        <div className={styles.imageContainer}>
          <Image src={qrCodeUrl} alt={`${PAGE_ROUTES.SOCIETIES}/${slug}`} />
        </div>
      </div>
      <div className={styles.qrCodeModalAction}>
        <ButtonV3 color="secondary" onClick={downloadQR}>
          Download QR code
        </ButtonV3>
        <ButtonV3 color="primary" onClick={onClose}>
          Done
        </ButtonV3>
      </div>
    </Modal>
  );
};
